import _styled from "styled-components";
const _excluded = ["children", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
const PanelContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    ref: ref,
    $_css: [{
      position: 'relative',
      display: 'flex',
      height: '100%',
      width: '100%'
    }, style]
  }), children);
});
PanelContainer.displayName = 'PanelContainer';
PanelContainer.propTypes = {
  /** Panel content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType
};
export default PanelContainer;
var _StyledDiv = _styled("div").withConfig({
  displayName: "PanelContainer___StyledDiv",
  componentId: "sc-1oum37x-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=PanelContainer.js.map